import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.exporting {

  export class RelativityWorkspaceService extends Service<any> {
    constructor(resource: any, rootScope: IRootScope, private configService, resourceWrapperService, private httpService) {
      super({resource, rootScope, resourceWrapperService});

      let relativityWorkspaceResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/relativity/workspace/:id`,
        {id: "@id", projectId: "@projectId"});

      this.itemResource = this.resourceWrapperService.WrapActions(relativityWorkspaceResource);
    }

    public GetFolders(projectId, workspaceId) {
      let url = `${this.configService.getServerBaseUrl()}/project/${projectId}/relativity/workspace/${workspaceId}/folders`;

      return this.httpService.$http({
        method: "GET",
        url: url
      });
    }

    public GetFields(projectId, workspaceId) {
      let url = `${this.configService.getServerBaseUrl()}/project/${projectId}/relativity/workspace/${workspaceId}/fields`;

      return this.httpService.$http({
        method: "GET",
        url: url
      });
    }
  }

  frontendApp.factory("RelativityWorkspaceService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "HttpService", Factory.Create(RelativityWorkspaceService)]);
}
